import validator from "validator";
import isEmpty from "lodash/isEmpty";
import { spaceRegex } from "../../constants/common";

export function ValidateCorporateInput(data) {
  let errors = {};

  if (data.first_name !== undefined && validator.isEmpty(data.first_name)) {
    errors.first_name = "First name  is required";
  }

  if (
    data.first_name !== undefined &&
    !validator.isEmpty(data.first_name) &&
    data.first_name.length > 40
  ) {
    errors.first_name = "First name should be less than  of 40 characters only";
  }

  if (
    data.first_name !== undefined &&
    !validator.isEmpty(data.first_name) &&
    spaceRegex.test(data.first_name) === false
  ) {
    errors.first_name = "First name  is invalid";
  }

  if (data.last_name !== undefined && validator.isEmpty(data.last_name)) {
    errors.last_name = "Last name  is required";
  }
  if (
    data.last_name !== undefined &&
    !validator.isEmpty(data.last_name) &&
    data.last_name.length > 40
  ) {
    errors.last_name = "Last name should be less than  of 40 characters only";
  }

  if (
    data.last_name !== undefined &&
    !validator.isEmpty(data.last_name) &&
    spaceRegex.test(data.last_name) === false
  ) {
    errors.last_name = "Last name  is invalid";
  }

  if (data.phone !== undefined && validator.isEmpty(data.phone)) {
    errors.phone = "Mobile no is required";
  }
  if (
    data.no_of_employee !== undefined &&
    validator.isEmpty(data.no_of_employee)
  ) {
    errors.no_of_employee = "No of employee is required";
  }
  if (
    data.no_of_employee !== undefined &&
    validator.isEmpty(data.no_of_employee) === false
  ) {
    if (!validator.isNumeric(data.no_of_employee)) {
      errors.no_of_employee = "Please enter valid no of employee";
    }
  }

  if (data.company_name !== undefined && validator.isEmpty(data.company_name)) {
    errors.company_name = "company name is required";
  }

  if (data.position !== undefined && validator.isEmpty(data.position)) {
    errors.position = "position is required";
  }

  // if (
  //   data.business_type !== undefined &&
  //   validator.isEmpty(data.business_type)
  // ) {
  //   errors.business_type = "bussiness type is required";
  // }

  if (data.phone !== undefined && validator.isEmpty(data.phone) === false) {
    if (!validator.isLength(data.phone, { min: 10, max: 10 })) {
      errors.phone = "Mobile no should be of 10 digit";
    }
  }

  if (data.phone !== undefined && validator.isEmpty(data.phone) === false) {
    if (!validator.isNumeric(data.phone)) {
      errors.phone = "Please enter valid mobile number";
    }
  }

  if (data.email !== undefined && validator.isEmpty(data.email)) {
    errors.email = "Email is required";
  }

  if (data.email !== undefined && validator.isEmpty(data.email) === false) {
    if (!validator.isEmail(data.email)) {
      errors.email = "Email is invalid";
    }
  }

  if (
    data.email !== undefined &&
    !validator.isEmpty(data.email) &&
    data.email.length > 40
  ) {
    errors.email = "Email should be less than  of 40 characters only";
  }

  console.log("DATA", data);
  console.log("errors", errors);

  return { errors, isValid: isEmpty(errors) };
}
